import { ApiService } from '../../ApiService';
import snakecaseKeys from 'snakecase-keys';
import { Note } from '../../../entities/ApplicationFeed';

interface NoteDto {
  note: string;
}
interface CreateNoteDto extends NoteDto {
  applicationId: number;
}

interface EditNoteDto extends NoteDto {
  id: number;
}

export interface NotesFeedResponse {
  data: Note[];
  nextPage: number | null;
  totalCount: number;
}

export class NoteService {
  public static list(
    applicationId: number,
    page: number,
    perPage: number,
    appliedAt?: Date,
  ): Promise<NotesFeedResponse> {
    return ApiService.get<NotesFeedResponse>(
      '/api/applicant_tracking/application_feeds',
      {
        application_id: applicationId,
        page,
        per: perPage,
        activity_types: ['notes'],
        ...(appliedAt && { start_date: new Date(appliedAt).toISOString() }),
      },
    );
  }

  public static create(props: CreateNoteDto): Promise<void> {
    return ApiService.post<void>(
      `/api/applicant_tracking/notes`,
      snakecaseKeys(props),
    );
  }

  public static edit(props: EditNoteDto): Promise<void> {
    return ApiService.put<void>(`/api/applicant_tracking/notes/${props.id}`, {
      note: props.note,
    });
  }

  public static delete(id: number): Promise<void> {
    return ApiService.delete<void>(`/api/applicant_tracking/notes/${id}`);
  }
}
